


import { NgModule } from '@angular/core';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingComponent } from './landing-page/landing/landing.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { IndexDropdownComponent } from './components/dropdowns/index-dropdown/index-dropdown.component';
import { FooterComponent } from './components/footers/footer/footer.component';
import { FAQsComponent } from './components/FAQs/faqs/faqs.component';
import { AboutUsComponent } from './components/about/about-us/about-us.component';
import { ContactUsComponent } from './components/contact/contact-us/contact-us.component';
import { NabarHomeComponent } from './components/navbar/nabar-home/nabar-home.component';
import { OrganizationsComponent } from './components/organizations/organizations.component';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    NavbarComponent,
    IndexDropdownComponent,
    FooterComponent,
    FAQsComponent,
    AboutUsComponent,
    ContactUsComponent,
    NabarHomeComponent,
    OrganizationsComponent,
    TermsConditionsComponent,
    PrivacyPolicyComponent,


  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
